var Store = require('@nichoth/state')
var _ = require('underscore')
var xtend = require('xtend')

function getEventID (data) {

}

var StreamTargetProviderStore = Store.extend({
    _state: {
        data: []
    },

    // streamTargets.getAltProviders.resolve
    set: function (data) {
        this._state.data = data
        return this.publish()
    }
});

function handleUpdate (eventID, data) {
    if (_.isArray(data)) {
        try {
            if (this._state.data.hasOwnProperty(eventID)) {
                this._state.data[eventID] = data
            } else {
                let updates = {}
                updates[eventID] = data
                this._state.data = xtend(this._state.data, updates)
            }
            return this.publish()
        } catch (error) {
            console.warn('StreamTargetDestinationStore.addTarget', error, data, this._state);
            return
        }
    }
}

var StreamTargetDestinationStore = Store.extend({
    _state: {
        data: {}
    },

    addTarget: handleUpdate,
    editTarget: handleUpdate,
    start: handleUpdate,
    stop: handleUpdate,

    deleteTarget: function (data) {

        let eventID = (data.eventID.indexOf('_') > -1) ?
            data.eventID.split('_')[1] : data.eventID

        if (this._state.data.hasOwnProperty(eventID)) {

            // Ensure it's in State
            let foundIndex = false
            this._state.data[eventID].map((destination, index) => {
                if (destination.altEventStreamID == data.altEventStreamID) {
                    foundIndex = index
                }
            })
            
            if (foundIndex !== false) {
                let tempState = this._state.data;
                // remove the deleted target
                (tempState[eventID].splice(foundIndex, 1));
                this._state.data = tempState;
                return this.publish()
            }
        }
    },

    reset: function () {
        this._state = {
            eventID: null,
            data: []
        }
        return this.publish()
    },

    // streamTargets.getAltDestinations.resolve
    set: function (eventID, data) {
        if (this._state.data.hasOwnProperty(eventID)) {
            this._state.data[eventID] = data
        } else {
            let updates = {}
            updates[eventID] = data
            this._state.data = xtend(this._state.data, updates)
        }
        return this.publish()
    }
});

/**
{
    id: NUMBER
    name: STRING
    server: STRING
    key: STRING
}
 */
var StreamTargetView = Store.extend({
    _state: {
        pending: false
    },

    addPending: function (data) {
        this._state.pending = data
        return this.publish()
    },

    reset: function () {
        this._state.pending = false
        return this.publish()
    }
});

export default {
    StreamTargetProviderStore: StreamTargetProviderStore,
    StreamTargetDestinationStore: StreamTargetDestinationStore,
    StreamTargetView: StreamTargetView
}